// Pages

const WORKFLOWS_PAGE = 'WORKFLOWS_PAGE';
const ARTICLE_PAGE = 'ARTICLE_PAGE';
const KNOWLEDGE_SEARCH_PAGE = 'KNOWLEDGE_SEARCH_PAGE';

export { WORKFLOWS_PAGE, ARTICLE_PAGE, KNOWLEDGE_SEARCH_PAGE };
